export enum EDynamicTitle {
	workspace = "{{workspaceTitle}}",
	site = "{{siteTitle}}",
}